import { Data_getInstance2dx6odfkdwlsm as Data_getInstance } from './adapter/SaveBoostMutation_ResponseAdapter.mjs';
import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Companion_getInstance8d9dd8emdwrf as Companion_getInstance } from './type/Mutation.mjs';
import { Builder320ghmibyd2no as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { SaveBoostMutationSelections_getInstance1r4pxampvw2nr as SaveBoostMutationSelections_getInstance } from './selections/SaveBoostMutationSelections.mjs';
import { SaveBoostMutation_VariablesAdapter_instance2lm8atx218dgg as SaveBoostMutation_VariablesAdapter_instance } from './adapter/SaveBoostMutation_VariablesAdapter.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(saveBoost) {
        this.j6s_1 = saveBoost;
      }
      toString() {
        return 'Data(saveBoost=' + this.j6s_1 + ')';
      }
      hashCode() {
        return this.j6s_1 == null ? 0 : getBooleanHashCode(this.j6s_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.j6s_1 == other.j6s_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.k6s_1 = obj(Data_getInstance());
        this.l6s_1 = (new (Builder())('data', Companion_getInstance().x6p_1)).q47(SaveBoostMutationSelections_getInstance().o6s_1).l38();
        this.m6s_1 = 'e36c069a6c3b1da025fd6b7d830edb88152eea68e636017c5acbf2e2fee0270e';
        this.n6s_1 = 'saveBoost';
      }
      a6q() {
        return 'mutation saveBoost($input: SaveBoostInput!) { saveBoost(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var SaveBoostMutationClass;
function SaveBoostMutation() {
  if (SaveBoostMutationClass === VOID) {
    class $ {
      constructor(input) {
        Companion_getInstance_0();
        this.p6s_1 = input;
      }
      c6q() {
        return 'e36c069a6c3b1da025fd6b7d830edb88152eea68e636017c5acbf2e2fee0270e';
      }
      operationId() {
        return this.c6q();
      }
      i4b() {
        return Companion_getInstance_0().a6q();
      }
      d6q() {
        return 'saveBoost';
      }
      operationName() {
        return this.d6q();
      }
      n4a(writer, customScalarAdapters, withDefaultValues) {
        SaveBoostMutation_VariablesAdapter_instance.q6s(writer, this, customScalarAdapters, withDefaultValues);
      }
      m4a() {
        return Companion_getInstance_0().k6s_1;
      }
      toString() {
        return 'SaveBoostMutation(input=' + this.p6s_1.toString() + ')';
      }
      hashCode() {
        return this.p6s_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SaveBoostMutation()))
          return false;
        if (!this.p6s_1.equals(other.p6s_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SaveBoostMutation', VOID, VOID, [Mutation()]);
    SaveBoostMutationClass = $;
  }
  return SaveBoostMutationClass;
}
//region block: exports
export {
  Data as Data20ir384tdyz1e,
  SaveBoostMutation as SaveBoostMutation360x4uh5hti27,
};
//endregion

//# sourceMappingURL=SaveBoostMutation.mjs.map
